export default "__VITE_ASSET__BnhPizeA__"